export enum GalleryBreakPoints {
	xs = 550,
	sm = 768,
	md = 1200,
	lg = 1760,
	xl = 3400,
}

